// Re-export from engine (moved to engine/patterns/)
export { animateGridPattern, invalidateTrimCache, resetAnimationState, drawShape } from '../engine/patterns/GridAnimatorEffects.js';
